import { db } from './db'
import type { Settings } from '$lib/types'

const KEY = 'singleton' as const

const DEFAULTS: Settings = {
  key: KEY,
  theme: 'dark',
  defaultZoom: 1,
  showGrid: true,
  showBuildingNames: true,
}

export async function get(): Promise<Settings> {
  const row = await db.settings.get(KEY)
  return row ?? DEFAULTS
}

export async function set(patch: Partial<Omit<Settings, 'key'>>): Promise<Settings> {
  const current = await get()
  const next: Settings = { ...current, ...patch, key: KEY }
  await db.settings.put(next)
  return next
}

export async function setLastOpenedPlan(planId: number | undefined): Promise<void> {
  await set({ lastOpenedPlanId: planId })
}

export async function setLastViewState(
  state: NonNullable<Settings['lastViewState']> | undefined,
): Promise<void> {
  await set({ lastViewState: state })
}
